export default __webpack_public_path__ + "static/media/TajMahal.de5c9d7a.png";